import Loading from "../../../../components/loading";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import UploadPhotoV2 from "../../../../components/uploading/uploadingPhotoV2";
import { IndexHook } from "./hooks";

const FormStoreLogo = () => {
	const {
		handleSubmit,
		setValue,
		isSubmitting,
		loading,
		url_logo,
		url_background,
		id_empresa,
		isUpdatedImage,
		setIsUpdatedImage,
		isUpdatedBackGround,
		setIsUpdatedBackGround,
		handleOnSubmit,
	} = IndexHook();

	const handleOpenUploadLogo = (e) => {
		e.preventDefault();
		const event = new CustomEvent("openUploadLogo");
		window.dispatchEvent(event);
	};

	const handleOpenUploadBackGround = (e) => {
		e.preventDefault();
		const event = new CustomEvent("openUploadBackground");
		window.dispatchEvent(event);
	};

	return (
		<>
			{loading ? (
				<Loading mensagem="Buscando imagens..." />
			) : (
				<form className="form" onSubmit={handleSubmit(handleOnSubmit)}>
					<main className="overflow-auto">
						<div className="row p-4">
							<div className="col-12 mb-4">
								<h5 className="text-lg font-semibold">Banner de Fundo</h5>
								<div className="mt-2">
									<img
										src={url_background}
										alt="Background"
										className="object-cover shadow-lg w-full max-h-60 rounded-lg"
									/>
								</div>
								<button className="btn btn-sm btn-outline-primary mt-3" onClick={handleOpenUploadBackGround}>
									Alterar Imagem de Fundo
								</button>
								{isUpdatedBackGround && (
									<span className="block text-red-500 font-bold mt-2">
										Clique em salvar para confirmar a alteração do fundo
									</span>
								)}
							</div>

							<div className="col-12">
								<h5 className="text-lg font-semibold">Logo da Empresa</h5>
								<div className="mt-2">
									<img
										src={url_logo}
										alt="Logo"
										className="object-contain shadow-lg max-h-52 rounded-lg border p-2"
									/>
								</div>
								<button className="btn btn-sm btn-outline-primary mt-3" onClick={handleOpenUploadLogo}>
									Alterar Logo
								</button>
								{isUpdatedImage && (
									<span className="block text-red-500 font-bold mt-2">
										Clique em salvar para confirmar a alteração da logo
									</span>
								)}
							</div>
						</div>
					</main>

					<footer>
						<BtnSubmit isSubmitting={isSubmitting} />
					</footer>

					<UploadPhotoV2
						onChange={(data) => {
							setIsUpdatedBackGround(true);
							setValue("url_background", data.url);
						}}
						nameImg={"back"}
						type="background"
						ident="openUploadBackground"
						id={id_empresa}
					/>
					<UploadPhotoV2
						onChange={(data) => {
							setIsUpdatedImage(true);
							setValue("url_logo", data.url);
						}}
						nameImg={"logo"}
						type="logo"
						ident="openUploadLogo"
						id={id_empresa}
					/>
				</form>
			)}
		</>
	);
};

export default FormStoreLogo;
